import { P, FF, shadow } from "../../styles/tokens";
import { MESES } from "../../constants/months";
import { NAV_ITEMS } from "../../constants/navigation";
import { ArboLogo, Divider } from "../ui";
import { useNavigation } from "../../contexts/NavigationContext";
import { useFinancial } from "../../contexts/FinancialContext";
import { useUI } from "../../contexts/UIContext";
import { sum } from "../../utils/format";

export default function Sidebar() {
  const { view, setView, section, activeMonth, setActiveMonth, navigateTo } = useNavigation();
  const { data, currentMonth, year } = useFinancial();
  const { setDukyOpen } = useUI();

  return (
    <nav aria-label="Navegacion principal" style={{ width:228, background:P.surface, borderRight:`1.5px solid ${P.border}`, display:"flex", flexDirection:"column", padding:"24px 0", position:"sticky", top:0, height:"100vh", flexShrink:0 }}>
      <div style={{ padding:"0 22px 22px", borderBottom:`1.5px solid ${P.border}`, marginBottom:16 }}>
        <ArboLogo size={28} showText />
        <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginTop:6 }}>{year} · Finanzas familiares</div>
      </div>
      <div style={{ padding:"0 10px 6px", marginBottom:6 }}>
        <div style={{ fontSize:9, fontWeight:700, color:P.textXs, fontFamily:FF, textTransform:"uppercase", letterSpacing:"0.10em", padding:"0 12px 8px" }}>Vistas</div>
        {NAV_ITEMS.map(v=>(
          <button key={v.id} onClick={()=>setView(v.id)} aria-current={view===v.id&&section!=="analisis"?"page":undefined}
            style={{ width:"100%", display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:12, border:"none",
              background: view===v.id&&section!=="analisis" ? P.ingresos.pastel : "transparent", color: view===v.id&&section!=="analisis" ? P.ingresos.text : P.textSm,
              cursor:"pointer", fontFamily:FF, fontSize:13, fontWeight: view===v.id&&section!=="analisis" ? 700 : 400, marginBottom:2, textAlign:"left" }}>
            <span style={{ fontSize:16, width:20, textAlign:"center" }}>{v.icon}</span>
            {v.label==="Mes"?"Mes actual":v.label==="Anual"?"Año completo":v.label==="Metas"?"Metas de ahorro":"Configuración"}
          </button>
        ))}
        <button
          onClick={() => navigateTo("mes", "analisis")}
          aria-current={view==="mes" && section==="analisis" ? "page" : undefined}
          style={{ width:"100%", display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:12, border:"none",
            background: view==="mes" && section==="analisis" ? P.ingresos.pastel : "transparent",
            color: view==="mes" && section==="analisis" ? P.ingresos.text : P.textSm,
            cursor:"pointer", fontFamily:FF, fontSize:13, fontWeight: view==="mes" && section==="analisis" ? 700 : 400,
            marginBottom:2, textAlign:"left" }}>
          <span style={{ fontSize:16, width:20, textAlign:"center" }}>📈</span>
          Análisis
        </button>
      </div>
      <Divider my={10} />
      <div style={{ flex:1, overflowY:"auto", padding:"0 10px" }}>
        <div style={{ fontSize:9, fontWeight:700, color:P.textXs, fontFamily:FF, textTransform:"uppercase", letterSpacing:"0.10em", padding:"0 12px 10px" }}>Meses</div>
        {MESES.map((mes,i)=>{
          const m=data[i], sav=sum(m.ingresos)-sum(m.fijos)-sum(m.extras);
          const hasData=sum(m.ingresos)>0||sum(m.fijos)>0, isActive=activeMonth===i;
          return (
            <button key={i} onClick={()=>{setActiveMonth(i);setView("mes");}}
              style={{ width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"9px 12px", borderRadius:10, border:"none",
                background: isActive ? P.bg : "transparent", color: isActive ? P.text : P.textSm,
                cursor:"pointer", fontFamily:FF, fontSize:13, fontWeight: isActive ? 700 : 400, marginBottom:1,
                borderLeft: isActive ? `3px solid ${P.ingresos.base}` : "3px solid transparent" }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                {mes}
                {i===currentMonth&&<span style={{ fontSize:8, fontWeight:700, color:P.textXs, background:P.bg, padding:"1px 6px", borderRadius:99, border:`1px solid ${P.border}` }}>HOY</span>}
              </div>
              {hasData&&<div style={{ width:7, height:7, borderRadius:"50%", background:sav>=0?P.ingresos.mid:P.danger.mid, flexShrink:0 }} />}
            </button>
          );
        })}
      </div>
      <div style={{ padding:"14px 12px 0" }}>
        <button onClick={()=>setDukyOpen(true)}
          style={{ width:"100%", padding:"13px 16px", borderRadius:16, border:"none", background:P.dark, cursor:"pointer", fontFamily:FF, display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ width:34, height:34, borderRadius:11, background:P.ingresos.base, display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>🐿️</div>
          <div style={{ textAlign:"left" }}>
            <div style={{ fontSize:12, fontWeight:700, color:"#fff", fontFamily:FF }}>Hablar con Duky</div>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.5)", fontFamily:FF }}>Tu consejera financiera IA</div>
          </div>
        </button>
      </div>
    </nav>
  );
}
